import script from "./HeaderAdminComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderAdminComponent.vue?vue&type=script&setup=true&lang=js"

export default script